import { APP_BASE_HREF } from '@angular/common';
import { ApplicationConfig, NgZone, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { provideLoaders } from '@frontend/loaders';
import { provideSafariBrowserToken } from '@frontend/ui/shared';
import { provideVanillaCore } from '@frontend/vanilla/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { providePaymentsFeatures } from '../../payments/cashier-app/src/app/payments.feature';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { provideSportsWebRootServices } from '../../sports/web/app/src/host-app/sports-web-integration.provider';
import { appRoutes } from './app.routes';
import { provideHostRouter } from './host-router';
import { provideHostApp } from './provide';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: NgZone,
            useValue: new NgZone({ shouldCoalesceEventChangeDetection: true }),
        },
        provideHostRouter(appRoutes),
        provideAnimationsAsync(),
        importProvidersFrom(
            StoreModule.forRoot(
                {},
                {
                    runtimeChecks: {
                        strictStateImmutability: false,
                        strictActionImmutability: false,
                        strictStateSerializability: false,
                        strictActionSerializability: false,
                    },
                },
            ),
            EffectsModule.forRoot([]),
        ),
        provideVanillaCore(),
        provideLoaders(),
        provideHostApp(),
        { provide: APP_BASE_HREF, useValue: '/' },
        provideSportsWebRootServices(),
        provideSafariBrowserToken(),
        //TODO: payments to remove TranslateModule
        providePaymentsFeatures(),
    ],
};
